/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';
import type { LeaderboardAntiFraudConfigResponse } from './LeaderboardAntiFraudConfigResponse';
import {
    LeaderboardAntiFraudConfigResponseFromJSON,
    LeaderboardAntiFraudConfigResponseFromJSONTyped,
    LeaderboardAntiFraudConfigResponseToJSON,
    LeaderboardAntiFraudConfigResponseToJSONTyped,
} from './LeaderboardAntiFraudConfigResponse';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { IScoringResponse } from './IScoringResponse';
import {
    IScoringResponseFromJSON,
    IScoringResponseFromJSONTyped,
    IScoringResponseToJSON,
    IScoringResponseToJSONTyped,
} from './IScoringResponse';
import type { LeaderboardTopEntryResponse } from './LeaderboardTopEntryResponse';
import {
    LeaderboardTopEntryResponseFromJSON,
    LeaderboardTopEntryResponseFromJSONTyped,
    LeaderboardTopEntryResponseToJSON,
    LeaderboardTopEntryResponseToJSONTyped,
} from './LeaderboardTopEntryResponse';
import type { LeaderboardRecurrenceConfigResponse } from './LeaderboardRecurrenceConfigResponse';
import {
    LeaderboardRecurrenceConfigResponseFromJSON,
    LeaderboardRecurrenceConfigResponseFromJSONTyped,
    LeaderboardRecurrenceConfigResponseToJSON,
    LeaderboardRecurrenceConfigResponseToJSONTyped,
} from './LeaderboardRecurrenceConfigResponse';
import type { CompetitionCustomRuleResponse } from './CompetitionCustomRuleResponse';
import {
    CompetitionCustomRuleResponseFromJSON,
    CompetitionCustomRuleResponseFromJSONTyped,
    CompetitionCustomRuleResponseToJSON,
    CompetitionCustomRuleResponseToJSONTyped,
} from './CompetitionCustomRuleResponse';
import type { LeaderboardParticipationConfigResponse } from './LeaderboardParticipationConfigResponse';
import {
    LeaderboardParticipationConfigResponseFromJSON,
    LeaderboardParticipationConfigResponseFromJSONTyped,
    LeaderboardParticipationConfigResponseToJSON,
    LeaderboardParticipationConfigResponseToJSONTyped,
} from './LeaderboardParticipationConfigResponse';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';
import type { TokenEntryConfigResponse } from './TokenEntryConfigResponse';
import {
    TokenEntryConfigResponseFromJSON,
    TokenEntryConfigResponseFromJSONTyped,
    TokenEntryConfigResponseToJSON,
    TokenEntryConfigResponseToJSONTyped,
} from './TokenEntryConfigResponse';
import type { EntryFeeConfigResponse } from './EntryFeeConfigResponse';
import {
    EntryFeeConfigResponseFromJSON,
    EntryFeeConfigResponseFromJSONTyped,
    EntryFeeConfigResponseToJSON,
    EntryFeeConfigResponseToJSONTyped,
} from './EntryFeeConfigResponse';
import type { LeaderboardCompetitionStatus } from './LeaderboardCompetitionStatus';
import {
    LeaderboardCompetitionStatusFromJSON,
    LeaderboardCompetitionStatusFromJSONTyped,
    LeaderboardCompetitionStatusToJSON,
    LeaderboardCompetitionStatusToJSONTyped,
} from './LeaderboardCompetitionStatus';
import type { LeaderboardPrizePoolResponse } from './LeaderboardPrizePoolResponse';
import {
    LeaderboardPrizePoolResponseFromJSON,
    LeaderboardPrizePoolResponseFromJSONTyped,
    LeaderboardPrizePoolResponseToJSON,
    LeaderboardPrizePoolResponseToJSONTyped,
} from './LeaderboardPrizePoolResponse';
import type { LeaderboardTimeConfigResponse } from './LeaderboardTimeConfigResponse';
import {
    LeaderboardTimeConfigResponseFromJSON,
    LeaderboardTimeConfigResponseFromJSONTyped,
    LeaderboardTimeConfigResponseToJSON,
    LeaderboardTimeConfigResponseToJSONTyped,
} from './LeaderboardTimeConfigResponse';
import type { LeaderboardAggregationMode } from './LeaderboardAggregationMode';
import {
    LeaderboardAggregationModeFromJSON,
    LeaderboardAggregationModeFromJSONTyped,
    LeaderboardAggregationModeToJSON,
    LeaderboardAggregationModeToJSONTyped,
} from './LeaderboardAggregationMode';
import type { LeaderboardLastCompletedPeriod } from './LeaderboardLastCompletedPeriod';
import {
    LeaderboardLastCompletedPeriodFromJSON,
    LeaderboardLastCompletedPeriodFromJSONTyped,
    LeaderboardLastCompletedPeriodToJSON,
    LeaderboardLastCompletedPeriodToJSONTyped,
} from './LeaderboardLastCompletedPeriod';
import type { ResolvedRuleRow } from './ResolvedRuleRow';
import {
    ResolvedRuleRowFromJSON,
    ResolvedRuleRowFromJSONTyped,
    ResolvedRuleRowToJSON,
    ResolvedRuleRowToJSONTyped,
} from './ResolvedRuleRow';

/**
 * A time-boxed competition tracking accumulated metrics
 * @export
 * @interface LeaderboardCompetitionResponse
 */
export interface LeaderboardCompetitionResponse {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    description?: string;
    /**
     * URL-friendly identifier
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    slug?: string;
    /**
     * Reference to OWGame ID (optional game scope)
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    gameId?: string;
    /**
     * Chat channel for this board (server-created at board creation)
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    chatChannelId?: string;
    /**
     * Parent Competition umbrella ID
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    competitionId?: string;
    /**
     * Hub that owns this leaderboard
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    surfaceId?: string;
    /**
     * When true, this leaderboard is part of the anti-cheat sentinel framework and is filtered out of all real-user-facing queries. Surfaced only on admin endpoints. Default false.
     * @type {boolean}
     * @memberof LeaderboardCompetitionResponse
     */
    isShadow?: boolean;
    /**
     * Data source types accepted (OVERWOLF, BLITZ, etc.)
     * @type {Array<string>}
     * @memberof LeaderboardCompetitionResponse
     */
    sources?: Array<string>;
    /**
     * Reference to reusable ScoringTemplate
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {LeaderboardCompetitionStatus}
     * @memberof LeaderboardCompetitionResponse
     */
    status: LeaderboardCompetitionStatus;
    /**
     * 
     * @type {LeaderboardTimeConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    timeConfig: LeaderboardTimeConfigResponse;
    /**
     * 
     * @type {LeaderboardAggregationMode}
     * @memberof LeaderboardCompetitionResponse
     */
    aggregationMode: LeaderboardAggregationMode;
    /**
     * 
     * @type {IScoringResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    scoring: IScoringResponse;
    /**
     * 
     * @type {LeaderboardParticipationConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    participationConfig: LeaderboardParticipationConfigResponse;
    /**
     * 
     * @type {LeaderboardAntiFraudConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    antiFraudConfig: LeaderboardAntiFraudConfigResponse;
    /**
     * 
     * @type {LeaderboardRecurrenceConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    recurrenceConfig: LeaderboardRecurrenceConfigResponse;
    /**
     * 
     * @type {LeaderboardPrizePoolResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    prizePool?: LeaderboardPrizePoolResponse;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof LeaderboardCompetitionResponse
     */
    entryType: CompetitionEntryType;
    /**
     * 
     * @type {EntryFeeConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    entryFeeConfig?: EntryFeeConfigResponse;
    /**
     * 
     * @type {TokenEntryConfigResponse}
     * @memberof LeaderboardCompetitionResponse
     */
    tokenEntryConfig?: TokenEntryConfigResponse;
    /**
     * Fee frequency for recurring leaderboards
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    entryFeeMode?: LeaderboardCompetitionResponseEntryFeeModeEnum;
    /**
     * PayoutTable ID for distributing entry fees to winners
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    payoutTableId?: string;
    /**
     * Minimum participants required for prizes to pay out; below this count all entry fees are refunded
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    minParticipants?: number;
    /**
     * Escrow ID for the current competition period
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    currentPeriodEscrowId?: string;
    /**
     * Opt out of live-stream tags on this board's standings. Absence means ON — a board with no setting shows tags.
     * @type {boolean}
     * @memberof LeaderboardCompetitionResponse
     */
    streamingDisabled?: boolean;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof LeaderboardCompetitionResponse
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * Assigned rule set from the shared rules library (layer 2 of the rules stack)
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    ruleSetId?: string;
    /**
     * Rules authored on this board only (layer 3) — a row whose label matches an inherited row replaces it, any other label appends
     * @type {Array<CompetitionCustomRuleResponse>}
     * @memberof LeaderboardCompetitionResponse
     */
    customRules?: Array<CompetitionCustomRuleResponse>;
    /**
     * The three rules layers already resolved for display. Attached by the public detail route; absent on admin reads.
     * @type {Array<ResolvedRuleRow>}
     * @memberof LeaderboardCompetitionResponse
     */
    resolvedRules?: Array<ResolvedRuleRow>;
    /**
     * Top leaderboard entries with rank and score
     * @type {Array<LeaderboardTopEntryResponse>}
     * @memberof LeaderboardCompetitionResponse
     */
    topEntries: Array<LeaderboardTopEntryResponse>;
    /**
     * Number of participants in the CURRENT period
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    totalParticipants: number;
    /**
     * Pre-registrations for the upcoming period (paid boards with a registration window)
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    nextPeriodParticipants?: number;
    /**
     * Hero image asset ID
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    hero?: string;
    /**
     * Banner image asset ID
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    banner?: string;
    /**
     * Admin user ID who created this leaderboard
     * @type {string}
     * @memberof LeaderboardCompetitionResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof LeaderboardCompetitionResponse
     */
    prerequisites?: Array<PrerequisiteResponse>;
    /**
     * IDs of EventPipelineFilter documents applied to this leaderboard's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof LeaderboardCompetitionResponse
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this leaderboard (PRODUCT_PLAN D2(b)). Each entry names one global filter this leaderboard opts out of, with a required reason and a required absolute expiry. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof LeaderboardCompetitionResponse
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this leaderboard still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a leaderboard that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof LeaderboardCompetitionResponse
     */
    failOpenOnMissingContext?: boolean;
    /**
     * True when the requesting user has an ACTIVE progression on this leaderboard for the current period. Set on authenticated list and detail responses; absent when unauthenticated.
     * @type {boolean}
     * @memberof LeaderboardCompetitionResponse
     */
    isParticipating?: boolean;
    /**
     * How many un-consumed virtual entry tokens the requesting user holds that this board's tokenEntryConfig accepts. Populated by the detail endpoint for authenticated callers on boards with a tokenEntryConfig; absent otherwise.
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    eligibleEntryTokenCount?: number;
    /**
     * The requesting user's current rank on this board. Populated by the detail endpoint for authenticated callers; null when joined but not yet ranked, absent when unauthenticated.
     * @type {number}
     * @memberof LeaderboardCompetitionResponse
     */
    userRank?: number | null;
    /**
     * 
     * @type {LeaderboardLastCompletedPeriod}
     * @memberof LeaderboardCompetitionResponse
     */
    lastCompletedPeriod?: LeaderboardLastCompletedPeriod;
}


/**
 * @export
 */
export const LeaderboardCompetitionResponseEntryFeeModeEnum = {
    ONE_TIME: 'ONE_TIME',
    PER_PERIOD: 'PER_PERIOD'
} as const;
export type LeaderboardCompetitionResponseEntryFeeModeEnum = typeof LeaderboardCompetitionResponseEntryFeeModeEnum[keyof typeof LeaderboardCompetitionResponseEntryFeeModeEnum];


/**
 * Check if a given object implements the LeaderboardCompetitionResponse interface.
 */
export function instanceOfLeaderboardCompetitionResponse(value: object): value is LeaderboardCompetitionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('timeConfig' in value) || value['timeConfig'] === undefined) return false;
    if (!('aggregationMode' in value) || value['aggregationMode'] === undefined) return false;
    if (!('scoring' in value) || value['scoring'] === undefined) return false;
    if (!('participationConfig' in value) || value['participationConfig'] === undefined) return false;
    if (!('antiFraudConfig' in value) || value['antiFraudConfig'] === undefined) return false;
    if (!('recurrenceConfig' in value) || value['recurrenceConfig'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    if (!('topEntries' in value) || value['topEntries'] === undefined) return false;
    if (!('totalParticipants' in value) || value['totalParticipants'] === undefined) return false;
    return true;
}

export function LeaderboardCompetitionResponseFromJSON(json: any): LeaderboardCompetitionResponse {
    return LeaderboardCompetitionResponseFromJSONTyped(json, false);
}

export function LeaderboardCompetitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardCompetitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'isShadow': json['isShadow'] == null ? undefined : json['isShadow'],
        'sources': json['sources'] == null ? undefined : json['sources'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'status': LeaderboardCompetitionStatusFromJSON(json['status']),
        'timeConfig': LeaderboardTimeConfigResponseFromJSON(json['timeConfig']),
        'aggregationMode': LeaderboardAggregationModeFromJSON(json['aggregationMode']),
        'scoring': IScoringResponseFromJSON(json['scoring']),
        'participationConfig': LeaderboardParticipationConfigResponseFromJSON(json['participationConfig']),
        'antiFraudConfig': LeaderboardAntiFraudConfigResponseFromJSON(json['antiFraudConfig']),
        'recurrenceConfig': LeaderboardRecurrenceConfigResponseFromJSON(json['recurrenceConfig']),
        'prizePool': json['prizePool'] == null ? undefined : LeaderboardPrizePoolResponseFromJSON(json['prizePool']),
        'entryType': CompetitionEntryTypeFromJSON(json['entryType']),
        'entryFeeConfig': json['entryFeeConfig'] == null ? undefined : EntryFeeConfigResponseFromJSON(json['entryFeeConfig']),
        'tokenEntryConfig': json['tokenEntryConfig'] == null ? undefined : TokenEntryConfigResponseFromJSON(json['tokenEntryConfig']),
        'entryFeeMode': json['entryFeeMode'] == null ? undefined : json['entryFeeMode'],
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'currentPeriodEscrowId': json['currentPeriodEscrowId'] == null ? undefined : json['currentPeriodEscrowId'],
        'streamingDisabled': json['streamingDisabled'] == null ? undefined : json['streamingDisabled'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'customRules': json['customRules'] == null ? undefined : ((json['customRules'] as Array<any>).map(CompetitionCustomRuleResponseFromJSON)),
        'resolvedRules': json['resolvedRules'] == null ? undefined : ((json['resolvedRules'] as Array<any>).map(ResolvedRuleRowFromJSON)),
        'topEntries': ((json['topEntries'] as Array<any>).map(LeaderboardTopEntryResponseFromJSON)),
        'totalParticipants': json['totalParticipants'],
        'nextPeriodParticipants': json['nextPeriodParticipants'] == null ? undefined : json['nextPeriodParticipants'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'banner': json['banner'] == null ? undefined : json['banner'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'isParticipating': json['isParticipating'] == null ? undefined : json['isParticipating'],
        'eligibleEntryTokenCount': json['eligibleEntryTokenCount'] == null ? undefined : json['eligibleEntryTokenCount'],
        'userRank': json['userRank'] == null ? undefined : json['userRank'],
        'lastCompletedPeriod': json['lastCompletedPeriod'] == null ? undefined : LeaderboardLastCompletedPeriodFromJSON(json['lastCompletedPeriod']),
    };
}

export function LeaderboardCompetitionResponseToJSON(json: any): LeaderboardCompetitionResponse {
    return LeaderboardCompetitionResponseToJSONTyped(json, false);
}

export function LeaderboardCompetitionResponseToJSONTyped(value?: LeaderboardCompetitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'slug': value['slug'],
        'gameId': value['gameId'],
        'chatChannelId': value['chatChannelId'],
        'competitionId': value['competitionId'],
        'surfaceId': value['surfaceId'],
        'isShadow': value['isShadow'],
        'sources': value['sources'],
        'scoringTemplateId': value['scoringTemplateId'],
        'status': LeaderboardCompetitionStatusToJSON(value['status']),
        'timeConfig': LeaderboardTimeConfigResponseToJSON(value['timeConfig']),
        'aggregationMode': LeaderboardAggregationModeToJSON(value['aggregationMode']),
        'scoring': IScoringResponseToJSON(value['scoring']),
        'participationConfig': LeaderboardParticipationConfigResponseToJSON(value['participationConfig']),
        'antiFraudConfig': LeaderboardAntiFraudConfigResponseToJSON(value['antiFraudConfig']),
        'recurrenceConfig': LeaderboardRecurrenceConfigResponseToJSON(value['recurrenceConfig']),
        'prizePool': LeaderboardPrizePoolResponseToJSON(value['prizePool']),
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'entryFeeConfig': EntryFeeConfigResponseToJSON(value['entryFeeConfig']),
        'tokenEntryConfig': TokenEntryConfigResponseToJSON(value['tokenEntryConfig']),
        'entryFeeMode': value['entryFeeMode'],
        'payoutTableId': value['payoutTableId'],
        'minParticipants': value['minParticipants'],
        'currentPeriodEscrowId': value['currentPeriodEscrowId'],
        'streamingDisabled': value['streamingDisabled'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'ruleSetId': value['ruleSetId'],
        'customRules': value['customRules'] == null ? undefined : ((value['customRules'] as Array<any>).map(CompetitionCustomRuleResponseToJSON)),
        'resolvedRules': value['resolvedRules'] == null ? undefined : ((value['resolvedRules'] as Array<any>).map(ResolvedRuleRowToJSON)),
        'topEntries': ((value['topEntries'] as Array<any>).map(LeaderboardTopEntryResponseToJSON)),
        'totalParticipants': value['totalParticipants'],
        'nextPeriodParticipants': value['nextPeriodParticipants'],
        'hero': value['hero'],
        'banner': value['banner'],
        'createdBy': value['createdBy'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'isParticipating': value['isParticipating'],
        'eligibleEntryTokenCount': value['eligibleEntryTokenCount'],
        'userRank': value['userRank'],
        'lastCompletedPeriod': LeaderboardLastCompletedPeriodToJSON(value['lastCompletedPeriod']),
    };
}

